import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-7',
  templateUrl: './7.component.html',
  styleUrls: ['./7.component.scss'],
})
export class VbTablesBootstrap7Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
